import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@docma-mm-core/config/config.service';
import { Users } from '@docma-mm-core/user/user';
import {joinUrl} from '@docma-mm-core/utils/utils';

@Injectable({
  providedIn: 'root'
})
export class FieldsFilterApiService {

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {}

  getProjectUsers(projectId: number, params?: {
    top?: number;
    skip?: number;
    terminatedAtIsNull?: boolean;
    terminatedToIsNull?: boolean;
    deactivatedAtIsNull?: boolean;
  }): Observable<Users> {
    const defaultParams = {
      top: 10000,
      skip: 0,
      terminatedAtIsNull: true,
      terminatedToIsNull: true,
      deactivatedAtIsNull: true,
      ...params
    };

    const queryParams = new URLSearchParams();
    queryParams.append('$top', defaultParams.top.toString());
    queryParams.append('$skip', defaultParams.skip.toString());

    const url = joinUrl(this.configService.getMmConfig().apiUrl, `/projects/${projectId}/users/search?${queryParams.toString()}`);

    return this.http.get<Users>(url);
  }

  getFaultCreatorsAndModifiers(projectId: number): Observable<Users> {
    return this.getProjectUsers(projectId);
  }
}
